// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-bordered-table .p-datatable-thead > tr > th,
.custom-bordered-table .p-datatable-tbody > tr > td {
    border: 1px solid #d1d5db !important;
    background: #fff;
    font-size: 12px; /* Added font size */
}

.custom-bordered-table .p-datatable-thead > tr > th {
    background: #f3f4f6;
    font-weight: 600;
    color: #22223b;
    text-align: left;
    padding: 0.75rem 1rem;
    font-size: 12px; /* Added font size */
}

.custom-bordered-table .p-datatable-tbody > tr > td {
    padding: 0.75rem 1rem;
    color: #22223b;
    font-size: 12px; /* Added font size */
}


.app-details {
  font-size: 12px;
  color: #222;
  margin-bottom: 8px;
}

.app-detail-row {
  margin-bottom: 4px;
  display: flex;
  align-items: flex-start;
}

.app-detail-label {
  font-size: 12px;
  color: #333;
  font-weight: 400;
  line-height: 1.4;
  word-break: break-word;
}

@media (max-width: 600px) {
  .app-details {
    font-size: 12px;
  }
  .app-detail-label {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/content/content.css"],"names":[],"mappings":"AAAA;;IAEI,oCAAoC;IACpC,gBAAgB;IAChB,eAAe,EAAE,oBAAoB;AACzC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,eAAe,EAAE,oBAAoB;AACzC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe,EAAE,oBAAoB;AACzC;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".custom-bordered-table .p-datatable-thead > tr > th,\n.custom-bordered-table .p-datatable-tbody > tr > td {\n    border: 1px solid #d1d5db !important;\n    background: #fff;\n    font-size: 12px; /* Added font size */\n}\n\n.custom-bordered-table .p-datatable-thead > tr > th {\n    background: #f3f4f6;\n    font-weight: 600;\n    color: #22223b;\n    text-align: left;\n    padding: 0.75rem 1rem;\n    font-size: 12px; /* Added font size */\n}\n\n.custom-bordered-table .p-datatable-tbody > tr > td {\n    padding: 0.75rem 1rem;\n    color: #22223b;\n    font-size: 12px; /* Added font size */\n}\n\n\n.app-details {\n  font-size: 12px;\n  color: #222;\n  margin-bottom: 8px;\n}\n\n.app-detail-row {\n  margin-bottom: 4px;\n  display: flex;\n  align-items: flex-start;\n}\n\n.app-detail-label {\n  font-size: 12px;\n  color: #333;\n  font-weight: 400;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n@media (max-width: 600px) {\n  .app-details {\n    font-size: 12px;\n  }\n  .app-detail-label {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
